<template>
    <div class="slide" :class="{first_slide}">
        <div class="slide_inner">
            <div class="backgrounds_wrapper" v-if="first_slide">
                <div class="background background_1" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="200"></div>
                <div class="background background_2" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="200"></div>
                <div class="background background_3" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="200"></div>
                <div class="background background_4" data-aos="fade-right" data-aos-duration="2000" data-aos-delay="200"></div>
                <div class="background background_5" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="200"></div>
            </div>
            <div class="slide_content grid-container" v-if="first_slide">
                <div class="lead_text" v-html="main_page.text" data-aos="fade-in" data-aos-duration="2000" data-aos-delay="2000"></div>
                <div class="twenties" data-aos="fade-in" data-aos-duration="2000" data-aos-delay="2000">
                    <div class="line" style="z-index:3">
                        <div class="num">20</div>
                        <div class="text">уголовных дел</div>
                    </div>
                    <div class="line">
                        <div class="num">20</div>
                        <div class="text">-тилетия</div>
                    </div>
                </div>
                <div class="hint_wrapper">
                    <div class="mouse_hint"></div>
                    <div class="kbd_hint hide-for-small-only hide-for-medium-only">
                        <div class="arr t"></div>
                        <div class="arr l"></div>
                        <div class="arr d"></div>
                        <div class="arr r"></div>
                    </div>
                </div>
            </div>
            <div class="slide_content grid-container" v-if="!first_slide">
                <CaseType :caseType="content.category" />
                <div class="grid-x grid-margin-x">
                    <div class="cell small-12 medium-4 large-4 small-order-2 medium-order-1" style="position:relative">
                        <div class="case_slider hide-for-small-only hide-for-medium-only">
                            <ImgSlider v-if="content.slider.length" :slides=content.slider />
                        </div>
                        <div class="case_header">
                            <header>{{ content.title }}</header>
                            <h3 v-if="content.sub_title">{{ content.sub_title }}</h3>
                            <router-link :to="`/cases/${ slideIdx }`" class="button read_more">Узнать больше</router-link>
                            <div class="year_nav_wrapper show-for-small-only">
                                <YearNavigation :navigationData=navigation :slideIdx=slideIdx />
                            </div>
                        </div>
                    </div>
                    <div class="cell small-12 medium-6 large-8 small-order-1 medium-order-2">
                        <div class="grid-x grid-margin-x">
                            <div class="cell medium-12 large-10">
                                <img :src="content.imageUrl" :alt="content.title" style="display:block; width:100%;" ref="slide_img">
                                <div class="year_nav_wrapper hide-for-small-only hide-for-medium-only">
                                    <YearNavigation :navigationData=navigation :slideIdx=slideIdx />
                                </div>
                            </div>
                            <div class="cell medium-12 large-2 img_desc hide-for-small-only">
                                <span>{{ content.description }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="cell medium-2 hide-for-small-only hide-for-large medium-order-3">
                        <div class="year_nav_wrapper">
                            <YearNavigation :navigationData=navigation :slideIdx=slideIdx />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ImgSlider from '../components/ImageSlider'
    import CaseType from '../components/CaseType'
    import YearNavigation from '../components/YearNavigation'

    export default {
        name: 'slide',
        props: {
            content: {required:true, default:{} },
            slideIdx: { required:true },
            slidesNum: { required:true }
        },
        components: { ImgSlider, CaseType, YearNavigation },
        data: () => ({
            first_slide:false, main_page
        }),
        computed: {
            navigation(){
                let splitDate = JSON.stringify(this.content.year).split(', ')
                let year = splitDate[0],
                    month = splitDate[1] ? splitDate[1] : false,
                    prev = this.slideIdx != 0 ? `/slides/${this.slideIdx-1}` : false,
                    next = this.slideIdx < this.slidesNum-1 ? `/slides/${this.slideIdx+1}` : false
                return { year, month, prev, next }
            }
        },
        created(){
            this.first_slide = this.slideIdx == 0
        },
        methods: {
            goToPrev(){ this.$root.$emit('goToPrev', { slideIdx:this.slideIdx }) },
            goToNext(){ this.$root.$emit('goToNext', { slideIdx:this.slideIdx }) }
        }
    }
</script>

<style lang="scss">
    .slide {
        position:absolute; display:none; width:200vw; height:200vh; left:-50vw; top:-50vh; /*transition:opacity .1s ease;*/ transform:translate3D(0,0,0); opacity:1; will-change:opacity; background-color:$purple;
        .case_slider:after { background-color:$purple }
        &:nth-child(2n) {
            background-color:$purple-gray;
            .case_slider:after { background-color:$purple-gray }
        }

        &.out { display:none }

        .slide_inner {
            position:absolute; width:100vw; height:100vh; overflow-y:hidden; left:50vw; top:50vh;

            .slide_content {
                display:flex; flex-direction:column; justify-content:center; height:100%; padding:$space*2 $space $space; color:#fff;

                .case_type {
                    @include svg_text;
                }

                .case_slider {
                    position:relative; width:90%; margin-top:$space*2;
                    &:empty { display:none }
                    &:before, &:after { content:""; position:absolute; width:90%; height:100%; border:2px solid #6d6a6e; top:0; right:0 }
                    &:after { right:10px; top:10px }
                    .carousel {
                        position:relative; width:90%; height:90%; transform:translate(13px, 20px); z-index:1; border:2px solid #6d6a6e;
                        
                        img { display:block; width:100% }
                    }

                }

                    img {
                        opacity:1; transition:opacity .3s ease;
                        &.out { opacity:0; transition:opacity .1s ease }
                    }

                .case_header {
                    position:relative; z-index:1; transform:translateX(15%); width:120%; font-family:$sans-serif;padding-top:$space*3; filter:drop-shadow(0 0 1px rgba(0,0,0,.95));
                    header { font-size:fsz(3rem); font-weight:900; line-height:1 }
                    h3 { line-height:.9; margin-top:$space/2; }

                    @include small {
                        transform:none; padding-top:$space*2; width:100%;
                        header { font-size:2rem }
                    }

                    @include medium {
                        transform:translateX(5%); width:100%;
                        header { font-size:2rem }
                    }
                }

                .read_more {
                    @include golden-button;
                    @include small {
                        font-size:.75rem; display:block;
                    }    
                }

                .img_desc {
                    font-size:.8rem; display:flex; align-items:center; padding-bottom:$space*2;
                    @include medium { font-size:.6rem; line-height:1; margin-top:5px; padding-bottom:0 }    
                }

                .year_nav_wrapper {
                    transform:translate(78.7%, -50%);
                    
                    @include small { transform:none }
                    @include medium { transform:none; display:flex; justify-content:center; height:100%; align-items:center }
                }
            }

            h2 { font-size:calc(10vh + 1vw); text-transform:uppercase; line-height:.9; margin-bottom:$space*2; font-family:serif; font-weight:bold}
        }

        &.first_slide {
            background-color:#1b0e1f!important;

            .backgrounds_wrapper { opacity:.7 }
            .background {
                width:100%; height:100%; background-repeat:no-repeat; position:absolute; background-size:50%;
                &.background_1 {
                    background-image:url('~@/./assets/img/background_1.1.png'); background-size:30%; background-position:-5% 110%; z-index:2;
                    @include small {
                        background-size:40%; background-position:-15% 100%;
                    }    
                }
                &.background_2 {
                    background-image:url('~@/./assets/img/background_2.png'); background-position:45% 100%; z-index:2;
                    @include small {
                        background-size:60%; background-position:40% 100%;
                    }    
                }
                &.background_3 {
                    background-image:url('~@/./assets/img/background_3.png'); background-size:40%; background-position:94% 115%;
                    @include small {
                        background-position:107% 100%;
                    }    
                }
                &.background_4 {
                    background-image:url('~@/./assets/img/background_4.png'); background-size:20%; background-position:85% 10%;
                    @include small {
                        background-position:85% 70%
                    }
                }
                &.background_5 {
                    background-image:url('~@/./assets/img/background_5.png'); background-size:45%; background-position:7% 120%; z-index:1;
                    @include small {
                        background-size:60%; background-position:-12% 90%;
                    }    
                }
            }

            .hint_wrapper {
                position:absolute; z-index:2; left:50%; bottom:$space*3; transform:translateX(-50%); width:120px; height:60px; overflow:hidden;

                .kbd_hint { opacity:1; transition:opacity .5s ease; }    

                @include small {
                    bottom:$space*6; width:30px;
                    &:hover { width:30px!important }
                }
                @include medium {
                    bottom:$space*6; width:30px;
                    &:hover { width:30px!important }
                }
            }

            .mouse_hint {
                position:absolute; top:0; left:0; display:inline-block; z-index:2; width:30px; height:60px; background-image:url('~@/./assets/img/icon_mouse.png'), url('~@/./assets/img/icon_mouse_triangle.png'); background-repeat:no-repeat, no-repeat; background-position:50% 0, 50% 92%; background-size:30px, 18px; animation:mouse_arrow 2s ease 0s infinite; transition:left .2s ease;

                @keyframes mouse_arrow {
                    0%, 20%, 40%, 100% { background-position:50% 0, 50% 92% }
                    10% { background-position:50% 0, 50% 100% }
                }

                @include small {
                    @keyframes swipe {
                        0%, 20%, 40%, 100% { background-position:50% 50% }
                        10% { background-position:50% 0% }
                    }
                    transition:none; background-position:50% 50%; animation:swipe 2s ease 0s infinite; background-image:url('data:image/svg+xml;base64,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'); background-size: 114%;
                }

                @include medium {
                    @keyframes swipe {
                        0%, 20%, 40%, 100% { background-position:50% 50% }
                        10% { background-position:50% 0% }
                    }
                    transition:none; background-position:50% 50%; animation:swipe 2s ease 0s infinite; background-image:url('data:image/svg+xml;base64,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'); background-size: 114%;
                }
            }
            .kbd_hint {
                position:absolute; top:3px; left:60px; display:inline-block; z-index:2; width:60px; height:60px; opacity:0; transition:.5s ease;
                .arr {
                    position:absolute; width:20px; height:20px; border:1px solid #E8A52A; background-image:url('~@/./assets/img/arrow.svg'); background-repeat:no-repeat; background-size:12px; background-position:3px;
                    &.t { top:1px; left:19px; border-radius:2px 2px 0 0; animation:up 5s ease 0s infinite; transition:left .2s ease; transform:rotate(-90deg) }
                    &.l { top:20px; left:0; border-radius:2px 0 0 2px; animation:left 5s ease 0s infinite; transition:left .2s ease; transform:rotate(-180deg) }
                    &.d { top:20px; left:19px; animation:down 5s ease 0s infinite; transition:left .2s ease; transform:rotate(90deg) }
                    &.r { top:20px; left:38px; border-radius:0 2px 2px 0; animation:right 5s ease 0s infinite; transition:left .2s ease }
                }

                @keyframes left {
                    0%, 20%, 40%, 100% { background-color:transparent }
                    10% { background-color:#E8A52A }
                }

                @keyframes right {
                    0%, 20%, 40%, 100% { background-color:transparent }
                    30% { background-color:#E8A52A }
                }

                @keyframes up {
                    0%, 20%, 40%, 60%, 100% { background-color:transparent }
                    50% { background-color:#E8A52A }
                }

                @keyframes down {
                    0%, 20%, 40%, 60%, 80%, 100% { background-color:transparent }
                    70% { background-color:#E8A52A }
                }
            }

            .twenties {
                font-family:$gorod; line-height:1; color:#fff; letter-spacing:2px; font-size:fsz(2.8rem); transform:translateY(15%); z-index:2; user-select:none;
                
                .line {
                    position:relative; z-index:2; pointer-events:none;
                    &:first-child {
                        margin-bottom:50px;
                        @include medium {
                            margin-bottom:25px;
                        }    
                    }
                    .num { color:$golden; font-size:fsz(9.5rem); letter-spacing:20px; margin-bottom:$space }
                    .text { position:absolute; top:44%; top:calc(50% - #{$space}); left:38%; z-index:3; }

                    &:nth-child(1){
                        .text { top:calc(80% - #{$space}); left:26.5%; z-index:10 }
                    }
                    &:nth-child(2){
                        .text { left:38.5%; background:-webkit-radial-gradient(-10% 35%, circle cover, #c6a065, #89653a); -webkit-background-clip:text; -webkit-text-fill-color:transparent; filter:drop-shadow(1px 1px 1px black) }
                    }
                }

                @include small {
                    transform:translateY(-85%);
                    .line {
                        &:first-child { margin-bottom:$space }
                        &:nth-child(1){
                            .text { top:calc(111% - 0.9375rem)!important; font-size:1rem }
                        }
                        &:nth-child(2){
                            .text { top:calc(111% - 0.9375rem)!important; font-size:1rem }
                        }
                        .num { font-size:5rem!important; letter-spacing:0!important; }
                    }
                }

                @include medium {
                    transform:translateY(10%);
                    .line {
                        &:nth-child(1) .text { top:calc(81% - 0.9375rem)!important; font-size:2rem; left:37% }
                        &:nth-child(2) .text { top:calc(55% - 0.9375rem)!important; font-size:2rem; left:48% }
                    }
                }
            }    
            .lead_text {
                position:absolute; top:40%; transform:translate(-75%, -70%); width:20%; right:0; font-size:fsz(.9rem); font-weight:bold;
                p { line-height:1.3 }

                @include small {
                    top:340px; left:0; transform:none; width:100%; padding:$space; font-size:.8rem
                }
            }
        }
    }
</style>